<template>
	<div>
		<Navbar :title="title" :back="back" :transparent="navTransparent"></Navbar>

		<InstallApp />

		<div class="main" :style="{ backgroundColor: background }">
			<Loader :show="loading"></Loader>

			<div class="header" v-if="hasHeaderSlot">
				<slot name="header"></slot>
			</div>

			<slot v-if="!loading"></slot>
		</div>
		<Footer v-if="hasFooterSlot">
			<slot name="footer"></slot>
		</Footer>
	</div>
</template>
<script>
import Navbar from '@/components/layout/Navbar'
import Loader from '@/components/layout/Loader'
import Footer from '@/components/layout/Footer'
import InstallApp from '@/components/InstallApp'

export default {
	name: 'Layout',
	props: ['loading', 'title', 'background', 'back', 'footer', 'navTransparent'],
	components: {
		Navbar,
		Loader,
		Footer,
		InstallApp,
	},
	computed: {
		hasHeaderSlot() {
			return !!this.$slots.header
		},
		hasFooterSlot() {
			return !!this.$slots.footer
		},
	},
}
</script>

<style scoped>
.main {
	width: 100%;
	/* min-height: calc(100vh - 64px); */
	min-height: 100vh;
	display: flex;
	flex-direction: column;
}
.main.main-fixed {
	width: 100%;
	height: 100%;
	position: fixed;
}
.main .main-container {
	flex-grow: 1;
}
layout {
	flex-grow: 1;
}

.header {
	margin-top: 110px;
	padding: 0px 24px;
	color: #fff;
}
.header h1 {
	font-size: 18pt;
	font-weight: 600;
}
.header p {
}
</style>
